var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVimeo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.334 39.5734C116.854 49.9734 109.6 64.2134 95.5737 82.3467C81.067 101.333 68.8003 110.667 58.667 110.667C52.5337 110.667 47.2537 104.907 42.9337 93.3334C40.0003 82.88 37.3337 72.32 34.347 61.76C31.147 50.24 27.7337 44.48 24.0003 44.48C23.2537 44.48 20.4803 46.1867 15.6803 49.5467L10.667 43.04C16.0003 38.4 21.1203 33.76 26.2403 29.12C33.2803 23.04 38.5603 19.84 42.027 19.52C50.347 18.6667 55.467 24.4267 57.387 36.5867C59.467 49.76 60.907 57.92 61.707 61.12C64.0003 72 66.667 77.3334 69.6003 77.3334C71.8403 77.3334 75.2003 73.92 79.6803 66.8267C84.1603 59.7867 86.5603 54.4 86.8803 50.6667C87.5203 44.5867 85.1203 41.5467 79.6803 41.5467C77.1203 41.5467 74.507 42.1334 71.787 43.3067C77.0137 26.08 87.0403 17.7067 101.814 18.1867C112.8 18.5067 117.974 25.6534 117.334 39.5734Z",
    fill: "#32B8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/vimeo.69a0b05179ecf20a3cc39d57655cea88.svg";
export { ForwardRef as ReactComponent };